import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const ChartQuerySchema = z.object({
  // Paramètres de date (obligatoires pour un graphique)
  from: z.string().datetime({ message: "Format ISO 8601 requis (ex: 2026-01-01T00:00:00Z)" }),
  to: z.string().datetime({ message: "Format ISO 8601 requis" }),

  // Groupe d'agrégation (avec fallback 'day')
  groupBy: z.enum(["day", "week", "month", "year"]).default("day"),
});

export const ChartDataResponseSchema = z.object({
  labels: z.array(z.string()),
  datasets: z.object({
    label: z.string(),
    data: z.array(z.number()),
  }),
});
export class ChartQueryDto extends createZodDto(ChartQuerySchema) {}

export class ChartResponseDto extends createZodDto(ChartDataResponseSchema) {}
